module.exports = __webpack_public_path__ + "static/media/a-smarter-harvest-mobile.37bac88d.jpg";